import {
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'
import OxfordAccesCodes from "./OxfordAccessCodes";

export default ({ styles }) => {
    return (
    <div className={styles.instructions}>
      <h3>Instructions et déroulement</h3>
      <h4>Que prévoir avant de commencer le test de placement ?</h4>
      <ol>
          <li>Un ordinateur avec accès à Internet</li>
          <li>Javascript et Adobe FlashTM Player 9</li>
          <li>Des écouteurs si besoin</li>
          <li>Les différents codes annexés à ce document : Student name, User name, Password et Org ID</li>
          <li>
              Entre 50 et 80 minutes pour <strong>effectuer le test sans interruption
              (sinon vous perdez vos résultats)</strong>
          </li>
      </ol>
      <p>
          <strong>ATTENTION</strong> : pour être finalisé, le test de placement doit être entièrement
          effectué en 120 minutes.
      </p>
      <h4>Information d'accès</h4>
        <OxfordAccesCodes styles={styles} />
      <h4>Commencer le test</h4>
      <ol>
          <li>Obtenez les codes d’accès ci-dessus </li>
          <li>Allez sur <a href={'https://www.oxfordenglishtesting.com'} target="_blank">www.oxfordenglishtesting.com/login</a></li>
          <li>
              Entrez votre code d’utilisateur, votre mot de passe et le code d’identification de
              l’organisation sous Organisation login.
          </li>
          <li>Indiquez votre nom complet ainsi que votre adresse email</li>
          <li>Activez votre test en cliquant sur Oxford Online Placement Test</li>
          <li>Choisissez le niveau de difficulté de départ du test en fonction de votre niveau actuel</li>
          <li>Faites le test en suivant les instructions du site</li>
      </ol>
    </div>
    )
}
